module.exports = __webpack_public_path__ + "01_glasses_red.d5e852b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/01_glasses_red.png
// module id = ChuU
// module chunks = 0